import React from 'react'
import flow from '../C_Topics/assets/flow1.png'
const Jva_hello = () => {
    return (
        <div>
         <div className='container'>
            <h1>Print hello world 10 time using flow chart and pseudocode</h1>
            <p><strong>Pseudocode</strong></p>
            <div className='containers'>
            <ul>
                <li><strong>Step 1: </strong>Start</li>
                <li><strong>Step 2: </strong> Initialize count = 0</li>
                <li><strong>Step 3:</strong> While (count &lt; 10) <br />
Print (Hello World) <br />
Increment count by 1 <br />
While- end</li> 
                <li> <strong>Step 4:</strong>stop </li>
            </ul> </div>
            <p><strong>FlowChart</strong></p> <br /> <br />
            <div className='containers'>
            <img src={flow} alt="" />
</div>
        </div>       </div>
    )
}

export default Jva_hello
